import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { getGlobalAP } from '../../../../common/index.tsx';

const assignDataToGlobalAP = (data: Record<string, unknown>) => {
	Object.keys(data).forEach((key) => {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window._AP[key] = data[key];
		}
	});
};

const DEFAULT_DIALOG_OPTIONS_DATA_RESOURCE = {
	allJsVersion: '0.0.0',
	dialogModules: {},
	dialogOptions: {},
	inlineDialogOptions: {},
};

let promiseFetchConnectDialogOptionsData: null | Promise<Record<string, unknown>> = null;

const fetchConnectDialogOptionsData = () => {
	// caching the promise because we want to query this data only once in loaded page.
	if (promiseFetchConnectDialogOptionsData) {
		return promiseFetchConnectDialogOptionsData;
	}

	const url = '/rest/internal/latest/connect/data/dialog';
	promiseFetchConnectDialogOptionsData = fetch(url)
		.then((response) => response.json())
		.catch((error: Error) => {
			fireErrorAnalytics({
				error,
				meta: {
					packageName: 'jiraConnect',
					teamName: 'onecloud',
					id: 'fetchConnectDialogOptionsData',
				},
			});
			return DEFAULT_DIALOG_OPTIONS_DATA_RESOURCE;
		});

	return promiseFetchConnectDialogOptionsData;
};

export const registerDialogOptions = async () => {
	if (!getGlobalAP()) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window._AP = {};
	}

	const data = await fetchConnectDialogOptionsData();
	assignDataToGlobalAP(data);
};
